// frontend/src/pages/UnauthorizedPage.js
import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslation } from 'react-i18next';
import ThemeToggle from '../components/common/ThemeToggle';

function UnauthorizedPage() {
  const { t } = useTranslation();
  
  return (
    <Box
      className="hub360-auth"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        position: 'relative',
        p: 2,
      }}
    >
      <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
        <ThemeToggle />
      </Box>
      <Paper 
        elevation={3}
        sx={{
          p: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 500,
        }}
      >
        <LockIcon color="error" sx={{ fontSize: 100, mb: 2 }} />
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t('errors.accessDenied')}
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 4, textAlign: 'center' }}>
          {t('errors.accessDeniedDesc')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {/* `/dashboard` is the authenticated entry point: the route is
              wrapped in TenantRedirect which forwards to `/:orgName/` so an
              already-logged-in user lands on their tenant home instead of
              the public LandingPage mounted at `/`. */}
          <Button
            variant="contained"
            color="primary"
            component={RouterLink}
            to="/dashboard"
          >
            {t('errors.backToHome')}
          </Button>
          <Button
            variant="outlined"
            component={RouterLink}
            to="/login"
          >
            {t('errors.loginDifferentAccount')}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default UnauthorizedPage;